import axios from 'axios'
import cookie from 'js-cookie'
import Vue from 'vue'
import md5 from 'js-md5'
let Base64 = require('js-base64').Base64;

let axiosInstance = axios.create({
  baseURL: '/bg',
  withCredentials: true,
  headers: {
    'Accept': 'application/x.microapi.v2+json'
  },
  data: {

  },
  timeout: 10000
})

let px = (obj) => {
  var newkey = Object.keys(obj).sort();
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]];
  }
  return newObj;
}

let key = 'phpapiv1';

axiosInstance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (typeof config.data != 'object') {
    config.data = {}
  }
  config.data.token = cookie.get('token') || '';
  config.data.timestamp = new Date().getTime();
  if (config.data.keyword == null) {
    delete config.data.keyword
  }
  var oldObj = {},
    configObj = config.data;
  for (var d in configObj) {
    oldObj[d] = configObj[d]
  }
  oldObj.key = key;
  var newObj = px(oldObj),
    str = '';
  for (var s in newObj) {
    str += (s + '=' + newObj[s] + '&');
  }
  str = str.substring(0, str.length - 1);
  var sign = md5(Base64.encode(str))
  config.data.sign = sign;
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(response => {
  //let hasToken = qs.parse(window.location.search.substring(1)).token
  if (response.data.code === 500010) {
    Vue.$vux.alert.show({
      title: '提示',
      content: '权限不足!',
      onHide() {
        history.back();
      }
    })
  }

  if (response.data.code == 500203) {
    Vue.$vux.alert.show({
      title: '提示',
      content: response.data.msg,
      onHide() {
        location.href = '/fr/app/investment/index'
      }
    })
  }

  var reg6 = new RegExp("^[67]\\d{6}$");
  if (reg6.test(response.data.code)) {
    Vue.$vux.alert.show({
      title: '提示',
      content: '系统出错,请联系客服进行反馈',
      onHide() {}
    })
  }
  if (response.data.code == 500015 || response.data.code == 500016) {
    // cookie.remove('token');
    // location.reload();
  }
  return response.data
}, error => {
  error = error.toString()
  if (error.search('timeout') != -1) {
    Vue.$vux.loading.hide();
    Vue.$vux.toast.show({
      text: '请求超时,请刷新重试',
      width: '15em'
    })
  } else {
    return {
      'code': 500,
      'msg': error.toString()
    }
  }
})

export const http = axiosInstance

// new - 主题投资 - 主题
const getInversmentTheme = (cb, params) => {
  http.post(`/api/subject/investment`, params)
    .then(res => cb(res))
}

// new - 主题投资 - 主题详情
const getInversmentThemeDetails = (cb, params) => {
  http.post(`/api/subject/investment/info`, params)
    .then(res => cb(res))
}

// new - 主题投资 - 主题详情中的详情
const getInversmentThemeDetails2 = (cb, params) => {
  http.post(`/api/subject/investment/article/info`, params)
    .then(res => cb(res))
}


// new - 问股 - 问股首页
const postAskStock = (cb, params) => {
  http.post(`/api/problem/stock`, params)
    .then(res => cb(res))
}

// new - 问股 - 问股详情
const getAskStockHistoryDetails = (cb, params) => {
  http.post(`/api/problem/stock/history/info`, params)
    .then(res => cb(res))
}

// new - 问股 - 历史问股
const getAskStockHistoryRecord = (cb, params) => {
  http.post(`/api/problem/stock/history`, params)
    .then(res => cb(res))
}


// new - 非会员首页-投资要闻-广告
const getAdDetails = (cb, params) => {
  http.post(`/api/users/getAdDetail`, params)
    .then(res => cb(res))
}

// new - 文字直播
const getTextLive = (cb, params) => {
  http.post(`/api/text/live`, params)
    .then(res => cb(res))
}

// new - 二维码
const getQrcode = (cb, params) => {
  http.post(`/api/share/qr`, params)
    .then(res => cb(res))
}


// new - 巨牛直播
const getjnInfo = (cb, params) => {
  http.post(`/api/jn/live`, params)
    .then(res => cb(res))
}

// new - 丰牛直播
const getfnInfo = (cb, params) => {
  http.post(`/api/fn/live`, params)
    .then(res => cb(res))
}

// new - 个人中心
const getPersonalCenter = (cb, params) => {
  http.post(`/api/index/head`, params)
    .then(res => cb(res))
}

// new - jssdk
const getJssdkConfig = (cb, params) => {
  http.post(`/api/share/js_sdk/config`, params)
    .then(res => cb(res))
}

// new - 财经观察家讲师简介
const getLecturlInfo = (cb, params) => {
  http.post(`/api/lecturer/profile`, params)
    .then(res => cb(res))
}

// new - 财经观察家讲师详情
const getJrDetails = (cb, params) => {
  http.post(`/api/opinion/detail`, params)
    .then(res => cb(res))
}

// new - 首次申请投顾解答时验证是否已申请过
const getSureIfApply = (cb, params) => {
  http.post(`/api/user/is/bind/openid`, params)
    .then(res => cb(res))
}

// new - 财经观察家往期嘉宾
const getPastGuests = (cb, params) => {
  http.post(`/api/guest/list`, params)
    .then(res => cb(res))
}

// new - 使用说明
const getProductExplain = (cb, params) => {
  http.post(`/api/product/instruction`, params)
    .then(res => cb(res))
}

// new - 涨停板解密详情
const getUpAndDownDetails = (cb, params) => {
  http.post(`/api/article/category/detail`, params)
    .then(res => cb(res))
}

// new - 涨停板解密list
const getUpAndDownList = (cb, params) => {
  http.post(`/api/article/category/list`, params)
    .then(res => cb(res))
}

export default {
  getInversmentTheme,
  getInversmentThemeDetails,
  getInversmentThemeDetails2,
  postAskStock,
  getAskStockHistoryDetails,
  getAskStockHistoryRecord,
  getAdDetails,
  getTextLive,
  getQrcode,
  getjnInfo,
  getfnInfo,
  getPersonalCenter,
  getJssdkConfig,
  getLecturlInfo,
  getJrDetails,
  getSureIfApply,
  getPastGuests,
  getProductExplain,
  getUpAndDownDetails,
  getUpAndDownList,
}



// WEBPACK FOOTER //
// ./src/api/api_php.js